import React from "react";
import styled from "@emotion/styled";
import { Box, Divider } from "@mui/material";
import { DepotSynchronizationLog } from "@api";
import { SynchronizationLog } from "./SynchronizationLog";

const Container = styled.div`
  width: 100%;
`;

interface Props {
  depotSynchronizationLogs: DepotSynchronizationLog[];
}

export const SynchronizationLogList = ({ depotSynchronizationLogs }: Props) => {
  return (
    <Box display="flex" flexDirection="column" gap={6} width="100%">
      {depotSynchronizationLogs.map((depotSynchronizationLog, index) => {
        const isLast = index === depotSynchronizationLogs.length - 1;
        return (
          <React.Fragment
            key={`synchronizationLog-${depotSynchronizationLog.id}`}
          >
            <Container
              key={`synchronizationLog-${depotSynchronizationLog.id}`}
              data-testid={`synchronizationLog-${index}`}
            >
              <SynchronizationLog
                depotSynchronizationLog={depotSynchronizationLog}
              />
            </Container>
            {!isLast && <Divider />}
          </React.Fragment>
        );
      })}
    </Box>
  );
};
